import type { ReactNode } from 'react';

export const symbol_tonality_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M324-111.5Q251-143 197-197t-85.5-127Q80-397 80-480t31.5-156Q143-709 197-763t127-85.5Q397-880 480-880t156 31.5Q709-817 763-763t85.5 127Q880-563 880-480t-31.5 156Q817-251 763-197t-127 85.5Q563-80 480-80t-156-31.5ZM510-819v678q132-14 221-110.5T820-480q0-132-89-228T510-819Zm-60 47v-47q-38 4-74 16t-70 31h144Zm0 131v-71H231q-14 17-27.5 34T179-641h271Zm0 131v-71H156q-8 17-10 35t-3 36h307Zm0 131v-71H143q1 18 3 36t10 35h294Zm0 131v-71H179q10 20 24 37l28 34h219Zm0 107v-47H306q34 19 70 31.5t74 15.5Zm60-339Z"
		/>
	</svg>
);
